import zod from "zod";

export const purchaseOrderFormSchema = zod.object({
  orderNumber: zod.string().min(1),
  purchaseOrderFileSignedId: zod.string().refine((data) => data, {
    message: "cardAddDeliveryNote.deliveryNote.errorDropfile",
  }),
});

export const defaultValues = (orderNumber: string) => ({
  orderNumber: orderNumber,
  purchaseOrderFileSignedId: undefined,
});

export type InferredPurchaseOrderFormSchema = zod.infer<
  typeof purchaseOrderFormSchema
>;
